export type SsoPromptSegment =
  | { type: 'text'; text: string }
  | { type: 'login'; text: string }
  | { type: 'link'; text: string; href: string };

const LINK_PATTERN = /\[([^\]]+)\]\(([^)\s]+)\)/g;
const LOGIN_TARGET = 'login';

/**
 * Splits the organizer's prompt text into plain text, login and external link parts.
 * The links are written as [text](login) and [text](https://url). The text is never treated as HTML, and
 * a link with any other target (e.g. javascript:) is shown as plain text.
 */
export function parseSsoPrompt(text: string): SsoPromptSegment[] {
  const segments: SsoPromptSegment[] = [];
  const addText = (value: string) => {
    if (value) {
      segments.push({ type: 'text', text: value });
    }
  };

  let lastIndex = 0;
  for (const match of text.matchAll(LINK_PATTERN)) {
    const [whole, label, target] = match;
    addText(text.slice(lastIndex, match.index));
    lastIndex = match.index + whole.length;

    if (target === LOGIN_TARGET) {
      segments.push({ type: 'login', text: label });
    } else if (/^https?:\/\//i.test(target)) {
      segments.push({ type: 'link', text: label, href: target });
    } else {
      addText(label);
    }
  }
  addText(text.slice(lastIndex));

  return segments;
}
